import { useContent } from "@/context/ContentContext";
import { Reveal, LineReveal } from "@/components/Reveal";
import { QrCode, ArrowUpRight } from "lucide-react";

export default function Donate() {
  const { donations, settings } = useContent();
  const s = settings || {};

  return (
    <div data-testid="donate-page">
      <section className="border-b border-hairline/50 pt-40 pb-20 md:pt-52 md:pb-28">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="text-xs uppercase tracking-[0.32em] text-kinetic">Chip In</div>
          <h1 className="mt-6 max-w-4xl font-display text-6xl font-bold leading-[0.9] tracking-tighter text-bone md:text-8xl">
            <LineReveal text={"Fuel the\nMovement"} />
          </h1>
          <Reveal delay={0.4} className="mt-8 max-w-xl text-lg text-bone/70">
            <p>{s.donate_intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid gap-6 md:grid-cols-3">
          {donations.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.08}>
              <div
                data-testid={`donation-card-${i}`}
                className="flex h-full flex-col rounded-sm border border-hairline/60 bg-ink p-8 transition-colors duration-500 hover:border-kinetic/60"
              >
                <div className="flex items-center justify-between">
                  <h2 className="font-display text-3xl font-bold tracking-tight text-bone">{d.method}</h2>
                  <span className="text-kinetic">★</span>
                </div>
                {d.handle && <p className="mt-2 text-sm font-medium tracking-wide text-bone/80">{d.handle}</p>}

                <div className="my-8 flex aspect-square w-full items-center justify-center rounded-sm border border-dashed border-hairline bg-navy/60">
                  {d.qr_image_url ? (
                    <img src={d.qr_image_url} alt={`${d.method} QR code`} className="h-full w-full rounded-sm object-contain p-3" />
                  ) : (
                    <div className="flex flex-col items-center gap-3 text-bone/35">
                      <QrCode size={54} strokeWidth={1} />
                      <span className="text-xs uppercase tracking-widest">QR — add in CMS</span>
                    </div>
                  )}
                </div>

                {d.note && <p className="mb-6 whitespace-pre-line text-sm text-bone/55">{d.note}</p>}

                {d.url ? (
                  <a
                    href={d.url}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-auto inline-flex items-center justify-center gap-2 rounded-full bg-kinetic px-6 py-3 text-sm font-semibold uppercase tracking-wider text-white transition-transform duration-300 hover:-translate-y-0.5"
                  >
                    Give via {d.method} <ArrowUpRight size={16} />
                  </a>
                ) : (
                  <span className="mt-auto inline-flex items-center justify-center rounded-full border border-hairline px-6 py-3 text-xs uppercase tracking-widest text-bone/40">
                    Link coming soon
                  </span>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-16 max-w-2xl text-sm leading-relaxed text-bone/40">
            Contributions to Prascak 4 President are not tax-deductible. By donating you certify that you are a U.S. citizen or
            lawfully admitted permanent resident and that this contribution is made from your own funds.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
